module.exports = "### Using Typography\n\nCity of Helsinki uses bespoke typeface Helsinki Grotesk.\n\nHelsinki Grotesk is lisenced for use on Helsinki web services. Desktop usage (for example with design tools) requires a valid lisence from the user. The lisence can be obtained [from Camelot typefaces webshop](https://camelot-typefaces.com/helsinki-grotesk).\n\nFallback font when Helsinki Grotesk is not available is Arial.\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/docs/styles/Typography/Typography.md
// module id = 254
// module chunks = 0